import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Toaster, toast } from "sonner";

import AppLayout from "@/layouts/AppLayout";
import Landing from "@/pages/Landing";
import Dashboard from "@/pages/Dashboard";
import OfferBuilder from "@/pages/OfferBuilder";
import ClientAnalyzer from "@/pages/ClientAnalyzer";
import ProposalGenerator from "@/pages/ProposalGenerator";
import ValueLadder from "@/pages/ValueLadder";
import Library from "@/pages/Library";
import AuthCallback from "@/pages/AuthCallback";
import BillingSuccess from "@/pages/BillingSuccess";
import UpgradeScreen from "@/pages/UpgradeScreen";
import Privacidad from "@/pages/legal/Privacidad";
import Terminos from "@/pages/legal/Terminos";
import CookiesPolicy from "@/pages/legal/Cookies";
import AvisoLegal from "@/pages/legal/AvisoLegal";
import LegalIndex from "@/pages/legal/LegalIndex";
import AdminGuard from "@/components/AdminGuard";
import AdminSetup from "@/pages/admin/AdminSetup";
import AdminVerify from "@/pages/admin/AdminVerify";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import { AuthProvider } from "@/lib/auth";
import { ProtectedRoute, SubscriptionGuard } from "@/components/Guards";

function RouteToastCleaner() {
  const loc = useLocation();
  useEffect(() => { toast.dismiss(); }, [loc.pathname]);
  return null;
}

function AppRouter() {
  // Synchronous detection of session_id in URL fragment (prevents race conditions).
  if (typeof window !== "undefined" && window.location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <>
      <RouteToastCleaner />
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/legal" element={<LegalIndex />} />
        <Route path="/privacidad" element={<Privacidad />} />
        <Route path="/terminos" element={<Terminos />} />
        <Route path="/cookies" element={<CookiesPolicy />} />
        <Route path="/aviso-legal" element={<AvisoLegal />} />
        <Route path="/billing/success" element={<BillingSuccess />} />
        <Route path="/billing/cancel" element={<UpgradeScreen reason="trial" />} />
        <Route element={<ProtectedRoute />}>
          <Route element={<AdminGuard />}>
            <Route path="/admin/setup" element={<AdminSetup />} />
            <Route path="/admin/verify" element={<AdminVerify />} />
            <Route path="/admin" element={<AdminDashboard />} />
          </Route>
          <Route element={<AppLayout />}>
            <Route
              path="/dashboard"
              element={<SubscriptionGuard><Dashboard /></SubscriptionGuard>}
            />
            <Route
              path="/builder"
              element={<SubscriptionGuard><OfferBuilder /></SubscriptionGuard>}
            />
            <Route
              path="/analyzer"
              element={<SubscriptionGuard><ClientAnalyzer /></SubscriptionGuard>}
            />
            <Route
              path="/proposal"
              element={<SubscriptionGuard><ProposalGenerator /></SubscriptionGuard>}
            />
            <Route
              path="/value-ladder"
              element={<SubscriptionGuard><ValueLadder /></SubscriptionGuard>}
            />
            <Route
              path="/library"
              element={<SubscriptionGuard><Library /></SubscriptionGuard>}
            />
          </Route>
        </Route>
      </Routes>
    </>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <AppRouter />
        </BrowserRouter>
      </AuthProvider>
      <Toaster position="top-right" theme="light" duration={3000} />
    </div>
  );
}

export default App;
